import { useContext } from "react";
import { NavToolbarPublisherContext } from "#nav-toolbar-slots-context";
export function useNavToolbarPublisher() {
  return useContext(NavToolbarPublisherContext);
}
